import { z } from '../zod.js';

/**
 * Email schema that trims whitespace and lowercases before validating as an email.
 * Use this for any user-supplied email input so storage stays case-insensitive
 * and matches Mongoose's `{ lowercase: true, trim: true }` setters (which do
 * NOT run on `findOneAndUpdate`).
 */
export const NormalizedEmailSchema = z.preprocess(
  value => (typeof value === 'string' ? value.trim().toLowerCase() : value),
  z.email(),
);
